import { Component, OnInit, Input, Output, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'map-multi-areas',
  templateUrl: './multi-areas.component.html',
  styleUrls: ['./multi-areas.component.scss']
})
export class MultiAreasComponent implements OnInit {

  @Output() closeClick = new EventEmitter();
  @Output() saveClick = new EventEmitter();
  @Input() data: any[];
  @Input() lang: string;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
  }

  closeMultiAreas() {
    this.closeClick.emit();
  }

  savePage(id) {
    this.saveClick.emit(id);
  }

}
